export const farmaciasData = [
    {
      id: 0,
      nombre: "Farmacia Social (Av. de Mayo 39, Ramos Mejía)",
    },
    {
      id: 1,
      nombre: "Farmacia Moreno 90 (Moreno 90, Ramos Mejía)",
    },
    {
      id: 2,
      nombre: "Farmacia Rivadavia (Av. Rivadavia 14166, Ramos Mejía)",
    },
    {
      id: 3,
      nombre: "Farmacia Central Oeste Parati (Av. Rivadavia 14002, Ramos Mejía)",
    },
    {
      id: 4,
      nombre: "Farmacia Central Oeste (Av. de Mayo 427, Ramos Mejía)",
    },
    {
      id: 5,
      nombre: "Farmacia Central Oeste Martinoia (Av. de Mayo 899, Ramos Mejía)",
    },
    {
      id: 6,
      nombre: "Farmacia Rosales (Rosales 174, Ramos Mejía)",
    },
    {
      id: 7,
      nombre: "Farmacia Boutique Estilo Salud (Av. Rivadavia 13236, Ramos Mejía)",
    },
    {
      id: 8,
      nombre: "Farmacia Boutique Estilo Salud (Dr. Gabriel Ardoino 640, Ramos Mejía)",
    },
    {
      id: 9,
      nombre: "Farmacia Villa Sarmiento (Presidente Perón 79, Villa Sarmiento)",
    },
    {
      id: 10,
      nombre: "Otro",
    },
  ];